export default {
    namespaced: true,
    state: () => ({
        ThongTinDoanhNghiep: {
            TenDoanhNghiep: null,
            DiaChi: null,
            SoDienThoai: null,
            MaSoThue: null,
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinDoanhNghiep: (state) => {
            state.ThongTinDoanhNghiep = {
                TenDoanhNghiep: null,
                DiaChi: null,
                SoDienThoai: null,
                MaSoThue: null,
            };
        },
    },

    actions: {
        LayDanhSachDoanhNghiep(store) {
            store;
            let defaultData = {
                data: [],
                groupCount: 0,
                summary: [0],
                totalCount: 0,
            };
            var load = this.$Helper.Common.DevExDataSourceCustom(
                async (loadOptions) => {
                    this.startLoading();
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachDoanhNghiep")
                        ).Post(loadOptions);

                        if (resp.Data.status) {
                            let data =
                                resp.Data.data && resp.Data.data.data
                                    ? resp.Data.data
                                    : defaultData;
                            return data;
                        } else return defaultData;
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    } finally {
                        this.stopLoading();
                    }
                },
                "IdDnvt" || null,
                async (key) => {
                    try {
                        let resp = await this.$Core.Api.Make(
                            this.$i18n.global.t("url.DanhSachDoanhNghiep")
                        ).Post({
                            filter: ["IdDnvt", "=", key],
                        });
                        if (resp.StatusCode === 200) {
                            let data =
                                (resp.Data.data?.data || []).length > 0
                                    ? resp.Data.data.data[0]
                                    : {};
                            return data;
                        } else {
                            return {};
                        }
                    } catch (ex) {
                        if (ex.message == "Network Error")
                            throw Error("Không kết nối được đến máy chủ!");
                        throw ex;
                    }
                }
            );
            return load;
        },

        async TaoMoiDoanhNghiep(store) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.TaoMoiDoanhNghiep")
                ).Post(store.state.ThongTinDoanhNghiep);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async CapNhatDoanhNghiep(store) {
            try {
                let dataPost = {
                    IdDnvt: store.state.ThongTinDoanhNghiep.IdDnvt,
                    TenDoanhNghiep:
                        store.state.ThongTinDoanhNghiep.TenDoanhNghiep,
                    DiaChi: store.state.ThongTinDoanhNghiep.DiaChi,
                    SoDienThoai: store.state.ThongTinDoanhNghiep.SoDienThoai,
                    MaSoThue: store.state.ThongTinDoanhNghiep.MaSoThue,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.CapNhatDoanhNghiep")
                ).Put(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },

        async XoaDoanhNghiep({ state }, IdDnvt) {
            try {
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("url.DoanhNghiep") + `/${IdDnvt}`
                ).Delete();
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
